import * as Factory from 'factory.ts'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  GlobalSearchResultItem,
  type GlobalSearchResultItemConstructor,
} from './GlobalSearchResultItem'
import { GlobalSearchResultTypes } from '../enums'

// Default shape is ORDER_REQUEST. Tests for other types must override
// both `type` and `metadata` to produce a valid combination.
export const GlobalSearchResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.ORDER_REQUEST,
    uuid: 'uuid-1',
    id: '1',
    label: 'Test Requester',
    metadata: { status: 'pending-approval', date: '' },
  })

export const GlobalSearchResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  GlobalSearchResultItemConstructorFactory
)
